module.exports = __webpack_public_path__ + "static/media/logo.cd902af5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 17
// module chunks = 0